import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../src/app/store";
import { ErrorDisplay } from "../../../../src/components/ui/error/ErrorDisplay";
import { CustomLoadingSpinner } from "../../../../src/components/ui/spinners/LoadingSpinner";
import { fetchCaseDocuments } from "../../../../src/thunks/caseDocument";
import { DOCUMENT_PANEL_VISIBLE_TYPES } from "../config/DocumentPanelVisibleType";
import {
  selectDocumentsError,
  selectDocumentsLoading,
  selectVisibleDocumentsByTypes,
} from "../logic/caseDocumentsSelector";
import Documents from "./Document";
import { RETRIEVING_DATA_SUBTITLE } from "../../../lib/constants";

export default function DocumentPanel() {
  const dispatch = useAppDispatch();  

  const { id: case_id } = useParams<{ id: string }>();

  const visibleDocuments = useAppSelector((state) =>
    selectVisibleDocumentsByTypes(state, DOCUMENT_PANEL_VISIBLE_TYPES)
  );

  const isPending = useAppSelector(selectDocumentsLoading);
  const fetchError = useAppSelector(selectDocumentsError);

  useEffect(() => {
  if (!case_id) return;
  dispatch(fetchCaseDocuments({ case_id }));
}, [case_id, dispatch]);

  const handleRetry = () => {
        if (!case_id) return;
          dispatch(fetchCaseDocuments({case_id : case_id}))
      };
  
  if (isPending) {
      return (
        <div className="h-[100vh]">
          <CustomLoadingSpinner
           title="Loading Documents..."
           subtitle={RETRIEVING_DATA_SUBTITLE}
           minHeight="min-h-[100vh]" />
        </div>  
        );
      }
  
  if (fetchError) {
      return <ErrorDisplay error={fetchError} onRetry={handleRetry} />;
    }  
  
  if (!visibleDocuments.length) {
      return (
        <div className="p-6 text-center items-center rounded-lg">
          <h3 className="font-semibold text-lg mb-1">No Documents Found</h3>
          <p className="text-sm">This case does not have any associated documents.</p>
        </div>
      );
    }

  return (
    <div className="flex flex-col h-full bg-white mt-4 px-4 overflow-auto">
      <div className="flex-1 pb-20">
        <Documents documents={visibleDocuments} />
      </div>
    </div>
  );
}

